import store from '@/store/index'
import { getTenantFeaturePermissions } from '@/middlewares/permissions';

export async function storeDataInAthena(datakey, data) {

    const featurePermissions = getTenantFeaturePermissions()
    const permissionInventoryManagement  = featurePermissions.permissionInventoryManagement
    const group = store.state.userInfo?.tenant?.group

    // Validate datakey and group are not empty
    if (!datakey || datakey.trim() === '') {
        console.error('[storeDataInAthena] Validation Error: datakey cannot be empty');
        return;
    }
    
    if (!group || group.trim() === '') {
        console.error('[storeDataInAthena] Validation Error: tenant group cannot be empty');
        return;
    }

    if(!permissionInventoryManagement) {
        return 
    }

    const body = {
        "datakey": datakey,
        "data": data
    }

    // Store data in localStorage using datakey as key
    try {
        localStorage.setItem(`athena.${group}.${body.datakey}`, JSON.stringify(body.data));
    } catch (e) {
        console.error('[storeDataInAthena] Error saving to localStorage:', e);
    }
}